/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Fade from "@mui/material/Fade";

// Material Dashboard 2 PRO React TS Base Styles
import pxToRem from "../../common/functions/pxToRem";
import borders from "../base/borders";
import colors from "../base/colors";
import typography from "../base/typography";

const { tooltip: tooltipColor, white } = colors;
const { size, fontWeightRegular } = typography;
const { borderRadius } = borders;

// types
type Types = any;

const tooltip: Types = {
  defaultProps: {
    arrow: true,
    TransitionComponent: Fade,
    PopperProps: {
      modifiers: [
        {
          name: "flip",
          options: {
            fallbackPlacements: ["left", "right", "top", "bottom"],
          },
        },
      ],
    },
  },

  styleOverrides: {
    tooltip: {
      maxWidth: pxToRem(200),
      backgroundColor: tooltipColor.backgroundColor,
      color: white.main,
      fontSize: size.sm,
      fontWeight: fontWeightRegular,
      textAlign: "center",
      borderRadius: borderRadius.md,
      padding: `${pxToRem(4)} ${pxToRem(8)}`,
    },

    arrow: {
      color: tooltipColor.backgroundColor,
    },
  },
};

export default tooltip;
